import { validatePhoneNumber, validateEmail } from '../../features/AdviserProfileEditor/AdviserProfileContactDetailsEditor/adviserProfileContactDetailsEditorReducer.js'
import React from 'react';

const passwordMinimumLength = 10

export function validiateTextField (value, maxLen, isRequired) {
  if (!value && isRequired) {
    return {
      isInvalid: true,
      message: 'This field is required'
    }
  }
  if (value && maxLen && value.length > maxLen) {
    return {
      isInvalid: true,
      message: `The maximum length for this field is ${maxLen} characters`
    }
  }
  return {
    isInvalid: false,
    message: null
  }
}

export function validiateEmailField (value, isRequired) {
  if (!value) {
    return {
      isInvalid: !!isRequired,
      message: isRequired ? 'This field is required' : null
    }
  }
  if (value.length < 3 || value.indexOf('@') < 0 || value.slice(-1) === '.' || value.slice(-1) === '@') {
    return {
      isInvalid: true,
      message: 'Please enter a valid email address'
    }
  }
  return {
    isInvalid: false,
    message: null
  }
}

export function validiatePasswordField (value, confirmedValue) {
  if (!value) {
    return {
      isInvalid: true,
      message: 'This field is required'
    }
  }

  if (value && !value.match(/[a-z]/i)) {
    return {
      isInvalid: true,
      message: `The password must contain at least one letter.`
    }
  }

  if (value && !value.match(/[0-9]/i)) {
    return {
      isInvalid: true,
      message: `The password must contain at least one number.`
    }
  }

  if (value && value.length < passwordMinimumLength) {
    return {
      isInvalid: true,
      message: `The minimum length for this field is ${passwordMinimumLength} characters, yours is only ${value.length} characters long.`
    }
  }

  if (confirmedValue && value !== confirmedValue) {
    return {
      isInvalid: true,
      message: `The passwords do not match.`
    }
  }

  return {
    isInvalid: false,
    message: null
  }
}

export function validiateMoneyField (value, isRequired) {
  if (value !== 0 && !value && isRequired) {
    return {
      isInvalid: true,
      message: 'This field is required'
    }
  }
  if (value < 0) {
    return {
      isInvalid: true,
      message: 'This field cannot be negative'
    }
  }
  return {
    isInvalid: false,
    message: null
  }
}

export function validiateChecklistField (list, minimumSelected) {
  if (list.length < minimumSelected) {
    return {
      isInvalid: true,
      message: 'At least one must be selected'
    }
  }
  return {
    isInvalid: false,
    message: null
  }
}

export function validiateFileField (file, isRequired) {
  return {
    isInvalid: false,
    message: null
  }
}

export function validateProfileForApproval (profile) {
  // Guard the whole profile: the admin approval reducer calls this with a freshly fetched
  // profile that can still be undefined, which used to throw and break the screen.
  profile = profile || {}
  let invalidArr = []
  const profilePic = 'Profile Picture'
  const companyLogo = 'Company Logo'
  const firstName = 'First Name'
  const lastName = 'Last Name'
  const jobTitle = 'Job Title'
  const companyName = 'Company'
  const companyAddress = 'Company Address'
  const businessDescription = 'Business Description'
  const languages = 'Languages'
  const areasOfSpec = 'Services Offered'
  const clientTypes = 'Client Types'
  const phoneNumber = 'Phone Number'
  const emailAddress = 'Email Address'
  const minimumLumpSum = 'Minimum Lump Sum'
  const minimumMonthlyDebitOrder = 'Minimum Monthly Debit Order'

  if (!profile.firstName) {
    invalidArr.push(firstName)
  }

  if (!profile.lastName) {
    invalidArr.push(lastName)
  }

  if (!profile.profilePic) {
    invalidArr.push(profilePic)
  }

  if (!profile.companyLogo) {
    invalidArr.push(companyLogo)
  }

  if (!profile.title) {
    invalidArr.push(jobTitle)
  }

  if (!profile.company) {
    invalidArr.push(companyName)
  }

  if (!profile.companyAddress) {
    invalidArr.push(companyAddress)
  }

  if (!profile.blurb || profile.blurb.length === 0) {
    invalidArr.push(businessDescription)
  }

  // A missing collection is just as incomplete as an empty one, so absent data may not pass validation
  if (!profile.financialServicesOffered || profile.financialServicesOffered.length === 0) {
    invalidArr.push(areasOfSpec)
  }

  if (!profile.languagePreferences || profile.languagePreferences.length === 0) {
    invalidArr.push(languages)
  }

  if (!profile.clientTypePreferences || profile.clientTypePreferences.length === 0) {
    invalidArr.push(clientTypes)
  }

  const contactNumbers = profile.contactDetails && profile.contactDetails.contactNumbers
  if (!contactNumbers || contactNumbers.length === 0) {
    invalidArr.push(phoneNumber)
  } else if (!validatePhoneNumber(contactNumbers[0].contactNumber).valid) {
    invalidArr.push(phoneNumber)
  }

  if (!profile.contactDetails || !validateEmail(profile.contactDetails.publicContactEmailAddress).valid) {
    invalidArr.push(emailAddress)
  }

  // Investment minimums are mandatory to SUBMIT (a real value > 0), like every other field above.
  // They are NOT blocked while editing a WIP draft - only here, at submit-for-approval.
  const investmentMinimums = profile.investmentMinimums || {}
  if (!(investmentMinimums.minimumLumpSum > 0)) {
    invalidArr.push(minimumLumpSum)
  }
  if (!(investmentMinimums.minimumMonthlyDebitOrder > 0)) {
    invalidArr.push(minimumMonthlyDebitOrder)
  }

  return {
    valid: invalidArr.length === 0,
    invalidArr
  }
}
